module.exports = __webpack_public_path__ + "img/pl.88f47693.svg";